import {api} from '../middleware/api';

// Define endpoints using injectApi pattern
export const acmcompanyApi = api
  .enhanceEndpoints({addTagTypes: ['ACMCompany']})
  .injectEndpoints({
    endpoints: builder => ({
      getACMCompanys: builder.query<
        (ac_mcompany & ac_mcompanydetails)[],
        string
      >({
        query: cid => `acmcompany/${cid}`,
        providesTags: ['ACMCompany'],
      }),
      getACMCompany: builder.query<ac_mcompany & ac_mcompanydetails, string>({
        query: id => `acmcompany/byid/${id}`,
      }),
      importACMCompany: builder.mutation<{}, FormData>({
        query: (importData: FormData) => ({
          url: `acmcompany/import`,
          method: 'POST',
          body: importData,
        }),
        invalidatesTags: ['ACMCompany'],
      }),
      insertACMCompany: builder.mutation({
        query: acmcompany => ({
          url: `acmcompany/`,
          method: 'POST',
          body: acmcompany,
        }),
        invalidatesTags: ['ACMCompany'],
      }),
      updateACMCompany: builder.mutation({
        query: acmcompany => ({
          url: `acmcompany/`,
          method: 'PUT',
          body: acmcompany,
        }),
        invalidatesTags: ['ACMCompany'],
      }),
      deleteACMCompany: builder.mutation({
        query: acmcompany => ({
          url: `acmcompany/${acmcompany.cp_id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['ACMCompany'],
      }),
    }),
    overrideExisting: false,
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetACMCompanysQuery,
  useGetACMCompanyQuery,
  useImportACMCompanyMutation,
  useInsertACMCompanyMutation,
  useUpdateACMCompanyMutation,
  useDeleteACMCompanyMutation,
} = acmcompanyApi;

